import { FilterKindEnum } from '@hotjar/global-filters';
import type { GlobalFilter } from '@hotjar/global-filters';
import {
  MAX_DATA_RETENTION_PERIOD,
  START_DATE_OF_QUANTZ_DATA_COLLECTION,
  StatefulFilterChain,
} from '@hotjar/webapp/features/GlobalFilterChain/StatefulComponent/StatefulFilterChain';
import styled from '@emotion/styled';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import type { AdditionalTrackingData } from '@hotjar/dashboard-quantz';

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const SUPPORTED_FILTER_LIST: Set<FilterKindEnum> = new Set([
  FilterKindEnum.Error,
  FilterKindEnum.Clicked,
  FilterKindEnum.VisitedURL,
  FilterKindEnum.ReferrerURL,
  FilterKindEnum.LandingURL,
  FilterKindEnum.ExitURL,
  FilterKindEnum.NewReturningUserKind,
  FilterKindEnum.Country,
  FilterKindEnum.Event,
  FilterKindEnum.GoogleOptimize,
  FilterKindEnum.Optimizely,
  FilterKindEnum.Unbounce,
  FilterKindEnum.UserAttribute,
  FilterKindEnum.SessionDuration,
  FilterKindEnum.PageCount,
  FilterKindEnum.RageClickKind,
  FilterKindEnum.UTurnKind,
  FilterKindEnum.TeamComment,
  FilterKindEnum.UserID,
  FilterKindEnum.DeviceType,
  FilterKindEnum.Browser,
  FilterKindEnum.OS,
  FilterKindEnum.IncomingFeedback,
  FilterKindEnum.NPS,
]);

export type DashboardFilterChainProps = {
  currentFiltersInUiFormat: GlobalFilter;
  onFiltersChange: (filtersInUiFormat: GlobalFilter, segmentId?: number) => void;
  onUpsellRequest: (
    featureName: PlanComparisonReferrer,
    additionalTrackingData?: AdditionalTrackingData,
  ) => void;
};

export const DashboardFilterChain = ({
  currentFiltersInUiFormat,
  onFiltersChange,
  onUpsellRequest,
}: DashboardFilterChainProps): JSX.Element => {
  return (
    <Container>
      <StatefulFilterChain
        currentFiltersInUiFormat={currentFiltersInUiFormat}
        onChange={onFiltersChange}
        onUpsellRequest={(featureName, kind) =>
          onUpsellRequest(featureName as PlanComparisonReferrer, {
            ui_position: `dashboard.filters.${kind}`,
          })
        }
        hideSaveSegment
        usePrimaryStyledAddFilters
        supportedFilterList={SUPPORTED_FILTER_LIST}
        dateConstraint={
          MAX_DATA_RETENTION_PERIOD.minDate < START_DATE_OF_QUANTZ_DATA_COLLECTION.minDate
            ? START_DATE_OF_QUANTZ_DATA_COLLECTION
            : MAX_DATA_RETENTION_PERIOD
        }
        contextOfUse={{
          productType: ProductType.Analytics,
          page: 'dashboard',
          toolName: 'Dashboard',
        }}
      />
    </Container>
  );
};
